import { TreeView, type TreeViewProps } from '@progress/kendo-react-treeview'
import classNames from 'classnames'
import React from 'react'

import styles from './StyledTreeView.css'

export type StyledTreeViewProps = TreeViewProps & {
  'data-testid'?: string
}

export const StyledTreeView = ({
  className,
  'data-testid': dataTestId = 'components-elements-styled-tree-view',
  ...rest
}: StyledTreeViewProps) => (
  <TreeView
    className={classNames(styles.root, className)}
    data-testid={dataTestId}
    {...rest}
  />
)
